export default __webpack_public_path__ + "static/media/SAL1.6b1ba50f.webp";